import { PartnerPractice } from '@/shared/partner-practice';

export class State {
    public partnerPractices: Array<PartnerPractice> = [];
}
